import React from "react";
import Styles from "./styles";
import { GatsbyImage } from "gatsby-plugin-image";
import { useIntl, FormattedMessage } from "gatsby-plugin-react-intl";
import { useStaticQuery, graphql } from "gatsby";

const { ImageWrapper, InfoWrapper } = Styles;

const Salary = () => {
  const intl = useIntl();

  const { allFile } = useStaticQuery(graphql`
    query salaryQuery {
      allFile(filter: { name: { eq: "info-3" } }) {
        edges {
          node {
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED)
            }
          }
        }
      }
    }
  `);

  const test1 = intl.formatMessage({ id: "addInfo1" });
  const test2 = intl.formatMessage({ id: `salaryInfo` });

  console.log(test1);
  console.log(test2);

  return (
    <>
      <ImageWrapper>
        <GatsbyImage
          style={{
            width: "100%",
            maxHeight: "100%",
            minHeight: "100%",
          }}
          objectFit={"cover"}
          image={allFile.edges[0].node.childImageSharp.gatsbyImageData}
          alt={intl.formatMessage({ id: "addInfo1" })}
        />
      </ImageWrapper>
      <InfoWrapper>
        <h2>{intl.formatMessage({ id: "salaryTitle1" })}</h2>
        <p>{intl.formatMessage({ id: "salaryText1" })}</p>
        <ul>
          {(() => {
            let rows = [];
            for (let i = 1; i < 4; i++) {
              rows.push(
                <li key={i}>{intl.formatMessage({ id: `salaryInfo${i}` })}</li>
              );
            }
            return rows;
          })()}
        </ul>
        <p>{intl.formatMessage({ id: "salaryText2" })}</p>
      </InfoWrapper>
    </>
  );
};

export default Salary;
